import { queryOptions } from "@tanstack/react-query";

import { graphqlClient } from "@/api/graphql";
import { graphql } from "@/generated/digitalnisklady.cz";
import { Currency } from "@/generated/digitalnisklady.cz/graphql";

// eslint-disable-next-line lingui/no-unlocalized-strings
const companyQueryDocument = graphql(`
  query Company(
    $id: ID!
    $currency: Currency!
    $archived: Boolean
    $locale: String
  ) {
    company(id: $id) {
      id
      name
      storages(
        archived: $archived
        tradeType: FROM_STORAGE
        withNoOffers: true
      ) {
        edges {
          node {
            archived
            id
            address
            label
            lastPrices {
              edges {
                node {
                  crop {
                    id
                    name(locale: $locale)
                  }
                  date
                  price(currency: $currency)
                }
              }
            }
            offers {
              edges {
                node {
                  yearHarvested
                  orders {
                    edges {
                      node {
                        active
                        amount
                      }
                    }
                  }
                  id
                  amount
                  totalAmount
                  crop {
                    id
                    name(locale: $locale)
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`);

const companyQuery = ({
  currency,
  id,
  locale,
}: {
  id: string;
  locale: string;
  currency: Currency;
}) =>
  queryOptions({
    queryFn: () =>
      graphqlClient.request(companyQueryDocument, {
        currency: currency as Currency,
        id,
        locale,
      }),
    queryKey: ["company", id, currency, locale],
  });

export { companyQuery };
